import React, { Component } from "react";
import * as PropTypes from "prop-types";
import { Col, Form, Modal, Row, Switch, Tabs } from "antd";

import moment from "moment";

import { examService } from "./../../redux/services";

import {
	UIDrawerForm,
} from "./../../components";

import Files from "./files/index";

const config = {
	externalName: "exame",
};

class Show extends Component {
	static propTypes = {
		visible : PropTypes.bool.isRequired,
		onClose : PropTypes.func.isRequired,
		external: PropTypes.bool,
	};

	constructor(props) {
		super(props);

		this.state = {
			isLoading: true,
			uuid     : 0,
			item     : {},
		};
	}

	onOpen = (uuid) => {
		this.setState({
			isLoading: true,
			uuid     : uuid,
			item     : {},
		});

		examService.show({uuid})
		.then((response) => {
			let item = response.data.data;

			this.setState({
				isLoading: false,
				item     : item,
			}, () => {
				// Load options
				this.tabFiles && this.tabFiles.init(item);
			});
		})
		.catch((data) => {
			Modal.error({
				title  : "Ocorreu um erro!",
				content: String(data),
				onOk   : () => {
					// Force close
					return this.onClose();
				}
			});
		});
	};

	resetFields = () => {
		this.setState({
			item: {},
		});
	};

	onClose = () => {
		// Reset fields
		this.resetFields();

		// Callback
		this.props.onClose();
	};

	render() {
		const {visible}               = this.props;
		const {uuid, isLoading, item} = this.state;

		return (
			<UIDrawerForm
				visible={visible}
				width={700}
				onClose={this.onClose}
				isLoading={isLoading}
				showBtnSave={false}
				title={`Visualizar ${this.props.external ? config.externalName : "registro"} [${uuid}]`}>
				<Form layout="vertical">
					<Tabs defaultActiveKey="general">
						<Tabs.TabPane forceRender tab="Info. Gerais" key="general">
							<Row>
								<Col xs={24} sm={12}>
									<Form.Item label="Tipo">
										{item.type_name}
									</Form.Item>
								</Col>
								{!!item.category?.name && <Col xs={24} sm={12}>
									<Form.Item label="Categoria">
										{item.category?.name ?? '-'}
									</Form.Item>
								</Col>}
							</Row>
							<Form.Item label="Empresa">
								{item.tenant?.name ?? '-'}
							</Form.Item>
							<Form.Item label="Paciente">
								{item.customer?.name ?? '-'}
							</Form.Item>
							<Form.Item label="Nome">
								{item.name}
							</Form.Item>
							<Form.Item label="Responsável pelo exame">
								{item.responsible}
							</Form.Item>
							<Form.Item label="Data do exame">
								{item.date ? moment(item.date).format("dddd, D [de] MMMM [de] YYYY [as] HH:mm") : '-'}
							</Form.Item>
							<Form.Item label="Ativo">
								<Switch disabled checked={item.is_active} />
							</Form.Item>
							<Row gutter={16}>
								<Col xs={24} sm={12}>
									<Form.Item label="Criação">
										{moment(item.created_at).calendar()}
									</Form.Item>
								</Col>
								<Col xs={24} sm={12}>
									<Form.Item label="Última atualização">
										{moment(item.updated_at).calendar()}
									</Form.Item>
								</Col>
							</Row>
						</Tabs.TabPane>
						<Tabs.TabPane forceRender tab="Arquivos" key="files">
							<Files
								ref={el => this.tabFiles = el}
							/>
						</Tabs.TabPane>
					</Tabs>
				</Form>
			</UIDrawerForm>
		)
	}
}

export default Show;
